import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Stack,
    IconButton,
    InputAdornment,
    Box
  } from "@mui/material";
  import { Visibility, VisibilityOff } from "@mui/icons-material";
  import { useState } from "react";
  import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';

  const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjI1YzlkZDYxLWIwZDUtNDgxOC04ZGQxLTQ5NTZhOWVjMWUwYiIsImF1ZCI6IiIsImlzcyI6IiIsInN1YiI6IiIsImlhdCI6MTc1NDk3OTg3NCwianRpIjoiODhmNmJmMTEtZjkwYi00MDI0LWI3M2MtMmRiYThiNjM4NDllIiwiZXhwIjoxNzU0OTgwNzc0fQ.SJJPvWulMs8mxsBiOmVhraVaQgHSwk-pbGX74hZ04i8"
  const pitstop = "https://bimage-sgbuildex.pitstop.uat.dextech.ai"
  
  export default function LoginSGBuildexDialog({
    open,
    onCancel,
    onConfirm,
    connectorName = "Connector"
  }) {
    const [form, setForm] = useState({
      pitstop: pitstop,
      accesstoken: token,
    });
  
    const [showAccesstoken, setAccesstoken] = useState(false);
  
    const handleChange = (e) => {
      setForm(prev => ({
        ...prev,
        [e.target.name]: e.target.value
      }));
    };
  
    const handleSubmit = () => {
      onConfirm(form); // 👈 send all inputs
    };
  
    return (
      <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>

        <DialogContent>
        {/* 🔹 Connector Image */}
          <Box
            display="flex"
            justifyContent="center"
            mb={2}
          >
            <Box
              component="img"
              src={SGBuildex}
              alt={"sgbuildex"}
              sx={{
                width: 72,
                height: 72,
                objectFit: "contain"
              }}
            />
          </Box>

        <Stack spacing={2}>
          <TextField
            label="Pitstop URL"
            name="pitstop"
            value={form.pitstop}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Access Token"
            name="accesstoken"
            type={showAccesstoken ? "text" : "password"}
            value={form.accesstoken}
            onChange={handleChange}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setAccesstoken(v => !v)}
                    edge="end"
                  >
                    {showAccesstoken ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Stack>
      </DialogContent>
  
        <DialogActions>
          <Button onClick={onCancel} color="inherit">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={!form.pitstop || !form.accesstoken}
          >
            Connect
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  